import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AppService } from 'src/app/services/app/app.service';
import { JobService } from 'src/app/services/job/job.service';

interface Wages {
  hr: string | number,
  vat: string | number,
  total?: string | number,
  success?: string,
}
@Component({
  selector: 'app-job-summary',
  templateUrl: './job-summary.component.html',
  styleUrls: ['./job-summary.component.scss']
})
export class JobSummaryComponent {

  public userType!: string;
  public wagesData!: Wages;
  public wagesDataHr!: Wages;
  constructor(private jobService: JobService, private appService: AppService, @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private dialogRef: MatDialogRef<JobSummaryComponent>, private dialog: MatDialog) { }

  ngOnInit(): void {

    console.log(this.dialogData.repeatData);
    if (!this.dialogData.repeatData) {
      this.dialogData.repeatData = {
        "repeat": "0", // 0 = no, 1 = yes
      }
    }
    const userInfo = JSON.parse(this.appService.getData('training-portal.userInfo'));
    this.userType = userInfo.u_typ == 0 ? 'company' : (userInfo.u_typ == 1 ? 'recruiter' : 'admin');
    if (this.dialogData.formData) {
      this.getCostSummary()
    }

  }

  getCostSummary() {
    let allRec = 0;
    if (this.dialogData.formData.s_rec) {
      allRec = 1
    } else {
      if (this.dialogData.formData.rec.length != 0) {
        allRec = 0
      } else {
        allRec = 1
      }
    }
    let obj = {
      "j_c": this.dialogData.formData.j_c,
      "j_sc": this.dialogData.formData.j_sc,
      "type": '1', // 0 =company 1 = recruiter
      // "type": this.userType == 'recruiter' ? '1' : '0', // 0 =company 1 = recruiter
      // "all_rec": this.dialogData.s_rec && this.dialogData.rec ? '1' : '0', // 0 = no , 1 = yes
      "all_rec": allRec, // 0 = no , 1 = yes
      "rec": this.dialogData.formData.rec,
      "date": this.dialogData.formData.date,
      "qty": this.dialogData.formData.qty,
      "all_day": this.dialogData.formData.all_day ? '1' : '0',
      ...this.dialogData.repeatData
    }

    if (this.dialogData.formData.rec == null) {
      obj["rec"] = []
    }
    this.jobService.jobSummary(obj).subscribe({
      next: (success: any) => {
        if (success.status == 200) {
          this.wagesData = success.msg
          this.wagesDataHr = success.hourly
        }
      },
      error: (error: any) => { }
    })
  }

  onSubmit() {
    this.dialogRef.close({ confirm: "yes" })
  }
}